"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var client_1 = require("@apollo/client");
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var Button_1 = __importDefault(require("../../../../common/Button/Button"));
var Modal_1 = __importDefault(require("../../../../common/Modal/Modal"));
var Spinner_1 = __importDefault(require("../../../../common/Spinner/Spinner"));
var Table_1 = __importDefault(require("../../../../common/Table/Table"));
var Toast_1 = require("../../../../common/Toast");
var org_hook_1 = require("../../../../context/OrgContext/org.hook");
var getLanguages_1 = require("../../../../lib/getLanguages");
var icons_1 = __importDefault(require("../../../../theme/icons"));
var Mutation_1 = require("../Graphql/Mutation");
var Queries_1 = require("../Graphql/Queries");
var AddKnowledgeCategoryForm_1 = __importDefault(require("./AddKnowledgeCategoryForm"));
var KnowledgeCategory = function (_a) {
    var list = _a.list;
    var organization = (0, org_hook_1.useOrg)().organization;
    var _b = (0, react_i18next_1.useTranslation)(), i18n = _b.i18n, t = _b.t, iconRef = (0, react_1.createRef)(), _c = (0, react_1.useState)([
        {
            id: null,
            name: {},
            icon: null,
            sorting: null,
            organization_id: null,
        },
    ]), fields = _c[0], setFields = _c[1], _d = (0, react_1.useState)([{ icon: '' }]), fileName = _d[0], setFileName = _d[1], _e = (0, react_1.useState)([]), error = _e[0], setError = _e[1];
    var _f = (0, client_1.useMutation)(Mutation_1.DELETE_KNOWLEDGE_CATEGORY, {
        fetchPolicy: 'network-only',
        refetchQueries: [
            Queries_1.GET_KNOWLEDGE_CATEGORY,
            'getKnowledgeCategoryByOrganization',
        ],
    }), callDelete = _f[0], deleteKnowledgeResponse = _f[1], _g = (0, client_1.useMutation)(Mutation_1.UPSERT_KNOWLEDGE_CATEGORY, {
        fetchPolicy: 'network-only',
        refetchQueries: [
            Queries_1.GET_KNOWLEDGE_CATEGORY,
            'getKnowledgeCategoryByOrganization',
        ],
    }), callUpsertCategory = _g[0], upsertCategoryResponse = _g[1];
    (0, react_1.useEffect)(function () {
        getLanguageList();
    }, []);
    var getLanguageList = function () { return __awaiter(void 0, void 0, void 0, function () {
        var list;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, (0, getLanguages_1.getLanguages)()];
                case 1:
                    list = _a.sent();
                    setError([]);
                    setFields([
                        {
                            id: null,
                            name: list,
                            icon: null,
                            sorting: null,
                            organization_id: organization.id,
                        },
                    ]);
                    return [2 /*return*/];
            }
        });
    }); };
    var onEditClick = function (item) {
        var parsedName = JSON.parse(item.name);
        setFields([
            {
                id: item.id,
                name: parsedName,
                icon: null,
                sorting: item.sorting,
                organization_id: organization.id,
            },
        ]);
    }, onDeleteClick = function (item) {
        callDelete({
            variables: {
                id: item.id,
                organization_id: organization.id,
            },
        });
    };
    var triggerButton = function () { return (react_1.default.createElement("div", { className: 'absoulte-buttom', style: { top: '8.3rem' } },
        react_1.default.createElement(Button_1.default, { className: 'form-buttom', icon: react_1.default.createElement(icons_1.default, { name: 'plus', className: 'icon', height: 30, width: 30 }), text: t('add_category') }))); }, resetForm = function () {
        setFields([
            {
                id: null,
                name: {
                    en: '',
                    fr: '',
                    rn: '',
                },
                icon: null,
                sorting: null,
                organization_id: organization.id,
            },
        ]);
        setFileName([{ icon: '' }]);
    }, onSaveClick = function () {
        window.scrollTo(0, 0);
        var tmp = [], errortmp = [];
        fields.map(function (l, i) {
            if (l.name[i18n.language] === '') {
                errortmp.push({
                    type: 'name',
                    message: 'required',
                    index: i,
                });
            }
            else {
                var id = l.id, name_1 = JSON.stringify(l.name), icon = l.icon, sorting = l.sorting ? parseInt(l.sorting) : null;
                tmp.push({
                    id: id,
                    name: name_1,
                    icon: icon,
                    sorting: sorting,
                    organization_id: organization.id,
                });
            }
        });
        if (tmp.length === fields.length && tmp.length > 0) {
            callUpsertCategory({
                variables: { input: tmp },
            });
        }
        else {
            setError(errortmp);
        }
    };
    function handleChange(i, value, type) {
        setError([]);
        var values = __spreadArray([], fields, true);
        if (type === 'name') {
            values[i][type][i18n.language] = value;
        }
        else if (type === 'sorting') {
            values[i][type] = value;
        }
        else {
            values[i][type] = value;
            var file_name = __spreadArray([], fileName, true);
            file_name[i].icon = value.name;
            setFileName(file_name);
        }
        setFields(values);
    }
    var arrLength = fields.length - 1, addTextInput = function () {
        var values = __spreadArray([], fields, true);
        values.push({
            id: null,
            name: {
                en: '',
                fr: '',
                rn: '',
            },
            icon: null,
            sorting: null,
            organization_id: organization.id,
        });
        setFields(values);
        var file_name = __spreadArray([], fileName, true);
        file_name.push({ icon: '' });
        setFileName(file_name);
    }, removeTextInput = function (i) {
        var values = __spreadArray([], fields, true);
        values.splice(i, 1);
        setFields(values);
        var file_name = __spreadArray([], fileName, true);
        file_name.splice(i, 1);
        setFileName(file_name);
    }, createUI = function () { return (react_1.default.createElement(react_1.default.Fragment, null, fields.map(function (item, idx) {
        var _a;
        var findIndex = error.length > 0 &&
            error.find(function (i) { return i.index === idx; });
        return (react_1.default.createElement(react_1.Fragment, { key: idx },
            react_1.default.createElement(AddKnowledgeCategoryForm_1.default, { idx: idx, arrLength: arrLength, fileName: fileName[idx], imgref: iconRef, handleChange: handleChange, error: findIndex &&
                    findIndex.index === idx &&
                    findIndex.type === 'name' &&
                    findIndex.message, nameValue: (_a = item === null || item === void 0 ? void 0 : item.name) === null || _a === void 0 ? void 0 : _a[i18n.language], sortValue: item.sorting, addTextInput: function () { return addTextInput(); }, removeTextInput: function (i) { return removeTextInput(i); }, sortingList: list })));
    }))); };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        ((deleteKnowledgeResponse === null || deleteKnowledgeResponse === void 0 ? void 0 : deleteKnowledgeResponse.loading) ||
            (upsertCategoryResponse === null || upsertCategoryResponse === void 0 ? void 0 : upsertCategoryResponse.loading)) && react_1.default.createElement(Spinner_1.default, null),
        (deleteKnowledgeResponse === null || deleteKnowledgeResponse === void 0 ? void 0 : deleteKnowledgeResponse.data) && (react_1.default.createElement(Toast_1.ToastSuccess, { autoClose: 5000, closeOnClick: true, draggable: true, hideProgressBar: true, message: t('deleted_successfully'), newestOnTop: false, onClose: true, pauseOnFocusLoss: true, pauseOnHover: true, position: 'top-center', rtl: false })),
        (upsertCategoryResponse === null || upsertCategoryResponse === void 0 ? void 0 : upsertCategoryResponse.data) && (react_1.default.createElement(Toast_1.ToastSuccess, { autoClose: 5000, closeOnClick: true, draggable: true, hideProgressBar: true, message: t('added_successfully'), newestOnTop: false, onClose: true, pauseOnFocusLoss: true, pauseOnHover: true, position: 'top-center', rtl: false })),
        react_1.default.createElement(Modal_1.default, { onCloseClick: function () {
                resetForm();
            }, onSaveClick: function () { return onSaveClick(); }, title: 'add_category', triggerButton: triggerButton },
            react_1.default.createElement(react_1.default.Fragment, null,
                createUI(),
                react_1.default.createElement(Table_1.default, { list: list, onDeleteClick: onDeleteClick, onEditClick: onEditClick })))));
};
exports.default = KnowledgeCategory;
